import { defineStore } from 'pinia';
import { ref } from 'vue';
import serverFetch from '@globals/ServerFetch';
import RfpsList from '@customer/rfp/RfpsList';

export const useCustomerRfpListStore = defineStore('customerRfpList', () => {
	const state = {
		rfpsList: ref(new RfpsList('Rfps')),
		contactsList: ref(new RfpsList('Contacts')),
		displayAutomaticRecommendationsContactBanner: ref(false),
		displayAutomaticRecommendationsRfpListBanner: ref(false),
		displayExpandLimitBanner: ref(false),
		isFromListBox: ref(false),
		fromListType: ref(''),
		selectedRfpId: ref(-1),
		selectedRfp: ref(null),
		selectedListType: ref<'Rfps' | 'Contacts' | ''>(''),
		selectedFilterQuery: ref({}),
		photoPreview: ref(''),
		photoPreviewFilename: ref(''),
		isAutoUncover: ref(false),
		toggleChat: ref(false),
	};

	const actions = {
		getPublicRfpListUrl() {
			return actions.getList('Rfps').publicRfpListUrl || '/zapytania';
		},
		shouldDisplayExpandLimitBanner() {
			const banner = actions.getList('Rfps').expandLimitBanner;
			state.displayExpandLimitBanner.value = !!banner;
			return banner;
		},
		async shouldDisplayAutomaticRecommendationsBanner(isContacts: boolean) {
			// if (state.displayAutomaticRecommendationsContactBanner.value && isContacts) { return; }
			// if (state.displayAutomaticRecommendationsRfpListBanner.value && !isContacts) { return; }

			const url = `/customer/should-display-ap-${isContacts ? 'contacts' : 'rfp-list'}-stimulation-box.do`;
			const { shouldDisplayApStimulationBox: display } = await serverFetch(url, {}, 'GET', false, false);
			if (isContacts) {
				state.displayAutomaticRecommendationsContactBanner.value = display;
			} else {
				state.displayAutomaticRecommendationsRfpListBanner.value = display;
			}
		},
		getList(listType: 'Rfps' | 'Contacts') {
			const listName = listType ? listType.toLowerCase() : 'rfps';
			return state[`${listName}List` as 'rfpsList' | 'contactsList'].value;
		},
		updateFlags(flags: string[]) {
			if (flags && flags.indexOf('show_best_rfps') > -1) {
				actions.getList('Rfps').ShowBestRfps = true;
			}
		},
	};

	const getters = {};

	return { ...state, ...actions, ...getters };
});
